import React, { useContext } from 'react';
import { MapContext } from '../MapContext';
import CommonControls from './CommonControls';
import GeneControls from './GeneControls';
import HexaControls from './HexaControls';
import FictureControls from './FictureControls';
import RoiControls from './RoiControls';
import GeneGroupControls from './GeneGroupControls';
import './LayerPanel.css';

const LayerPanel = ({ layer, layerVisibility, layerExpanded, styles, layerProps, setLayerProps }) => {

  const handleCopyLink = () => {
    navigator.clipboard.writeText(layer.assetUrl).then(() => {
      console.log('Asset URL copied to clipboard');
    }).catch(err => {
      console.error('Could not copy text: ', err);
    });
  };

  return (
    <div className='layerPanel'>
      <LayerSpecificControls layer={layer} layerVisibility={layerVisibility} layerExpanded={layerExpanded} styles={styles} layerProps={layerProps} setLayerProps={setLayerProps} />
      <CommonControls layer={layer} layerVisibility={layerVisibility} styles={styles} />
    </div>
  );
}

const LayerSpecificControls = ({ layer, layerVisibility, layerExpanded, styles, layerProps, setLayerProps }) => {
  switch (layer.assetType) {
    case 'bg':
      return null;
    case 'hexa':
      return <HexaControls layer={layer} layerVisibility={layerVisibility} styles={styles} />;
    case 'gene':
      return <GeneControls layer={layer} layerVisibility={layerVisibility} layerExpanded={layerExpanded} styles={styles} layerProps={layerProps} setLayerProps={setLayerProps} />;
    case 'gene_group':
      return <GeneGroupControls layer={layer} layerVisibility={layerVisibility} layerExpanded={layerExpanded} styles={styles} layerProps={layerProps} setLayerProps={setLayerProps} />
    case 'fic':
      return <FictureControls layer={layer} layerVisibility={layerVisibility} styles={styles} />;
    case 'roi':
      return <RoiControls layer={layer} layerVisibility={layerVisibility} styles={styles} />;

    default:
      return null;
  }
};

export default LayerPanel;

